import { render } from "./EndPage.vue?vue&type=template&id=4d40596b&scoped=true&ts=true"
import script from "./EndPage.vue?vue&type=script&lang=ts"
export * from "./EndPage.vue?vue&type=script&lang=ts"

import "./EndPage.vue?vue&type=style&index=0&id=4d40596b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d40596b"]])

export default __exports__